export default __webpack_public_path__ + "static/quickFilter-9d615d88ab873a9fbcc1c3b9c8b1e931.gif";